<ng-select
  #accountSelector
  #accountSelectorModel="ngModel"
  (change)="onChange($event)"
  (clear)="onClear()"
  (remove)="onRemove($event)"
  (close)="onClose()"
  (open)="onOpen()"
  (scroll)="onScroll($event)"
  (scrollToEnd)="onScrollToEnd()"
  [searchFn]="searchFunc"
  [dropdownPosition]="dropdownPosition"
  [groupBy]="groupByFn"
  [groupValue]="groupValueFn"
  (search)="onSearch($event)"
  [(ngModel)]="selectedItems"
  [items]="items"
  [clearable]="clearable"
  [closeOnSelect]="closeOnSelect"
  [multiple]="multiple"
  [placeholder]="placeholder"
  [loading]="loading"
  [markFirst]="markFirst"
  [searchable]="searchable"
  [disabled]="disabled"
  [notFoundText]="notFoundTextLabel"
  [ngClass]="accountSelectorSizeClass"
  [compareWith]="compareItemsWith"
  [virtualScroll]="virtualScroll"
  [required]="required"
  [typeahead]="typeahead"
  [minTermLength]="minTermLength"
  [typeToSearchText]="typeToSearchText"
  (focus)="onFocus()"
  (blur)="onBlur()"
  bindLabel="name"
  class="bb-account-selector"
  name="bb-account-selector-ui"
  ngDefaultControl
>
  <!-- Template for item selected (single:ng-label-tmp) ng-label-tmp-->
  <ng-template let-item="item" ng-label-tmp>
    <ng-container *ngIf="customSingleSelectedItemLabel; else nglabeltmp">
      <ng-container
        *ngTemplateOutlet="
          customSingleSelectedItemLabel?.templateRef;
          context: {
            hostRef: hostRef,
            item: item
          }
        "
      ></ng-container>
    </ng-container>
    <!-- Default template for ng-label-tmp -->
    <ng-template #nglabeltmp>
      <bn-product-item-basic-account-ui
        [active]="false"
        [amount]="getLocalBalance(item)"
        [foreignAmount]="getForeignAmount(item)"
        [foreignCurrency]="getForeignCurrency(item)"
        [productNumber]="applyMaskToCardNumber(getProductNumber(item))"
        [currency]="item.currency"
        [productNumberFormat]="productNumberFormat"
        [showCurrencySymbol]="showCurrencySymbol"
        [bankBranchCode]="showBankBranchCode ? item.bankBranchCode : undefined"
        [title]="item.name"
        [status]="item.status"
        [highlight]="highlight"
        [balanceLabel]="balanceLabel"
      ></bn-product-item-basic-account-ui>
    </ng-template>
  </ng-template>

  <!-- Template for header, with search (ng-header-tmp) -->
  <ng-template ng-header-tmp>
    <ng-container class="bb-account-selector-dropdown__header">
      <section
        class="bb-account-selector-dropdown__header"
        [ngClass]="{ 'bb-account-selector-dropdown__header--hidden': !searchable }"
      >
        <bb-input-text-ui
          *ngIf="filterItems"
          (valueChange)="onFilterChange($event)"
          (focus)="ngSelect?.onInputFocus($event)"
          (blur)="ngSelect?.onInputBlur($event)"
          i18n-placeholder="Filter|Filter placeholder@@bb-account-selector-ui.filter.placeholder"
          placeholder="Filter"
          [autofocus]="true"
          [id]="ngSelect?.labelForId"
          [disabled]="ngSelect?.disabled"
          [readonly]="ngSelect?.itemsList.maxItemsSelected"
          [aria-autocomplete]="'list'"
          [aria-controls]="statusId"
          [aria-expanded]="ngSelect?.isOpen"
          [aria-invalid]="ariaInvalid"
          [aria-owns]="ngSelect?.isOpen ? ngSelect?.dropdownId : null"
          [aria-activedescendant]="ngSelect?.isOpen ? ngSelect?.itemsList?.markedItem?.htmlId : null"
          [aria-labelledby]="ariaLabelledby"
          [aria-describedby]="ariaDescribedby"
        ></bb-input-text-ui>
        <bb-search-box-ui
          *ngIf="!filterItems"
          (clear)="onClear()"
          (valueChange)="onFilterChange($event)"
          (submit)="onSearch($event)"
          (focus)="ngSelect?.onInputFocus($event)"
          (blur)="ngSelect?.onInputBlur($event)"
          placeholder="Search"
          i18n-placeholder="Search|Search placeholder@@bb-account-selector-ui.search.placeholder"
          [showClear]="true"
          showSearch="true"
          [role]="'combobox'"
          [autofocus]="true"
          [id]="ngSelect?.labelForId"
          [disabled]="ngSelect?.disabled"
          [readonly]="ngSelect?.itemsList.maxItemsSelected"
          [aria-autocomplete]="'list'"
          [aria-controls]="statusId"
          [aria-expanded]="ngSelect?.isOpen"
          [aria-invalid]="ariaInvalid"
          [aria-owns]="ngSelect?.isOpen ? ngSelect?.dropdownId : null"
          [aria-activedescendant]="ngSelect?.isOpen ? ngSelect?.itemsList?.markedItem?.htmlId : null"
          [aria-labelledby]="ariaLabelledby"
          [aria-describedby]="ariaDescribedby"
        ></bb-search-box-ui>
      </section>
      <div
        [id]="statusId"
        aria-live="assertive"
        aria-atomic="true"
        class="sr-only"
        role="status"
        i18n="
          Number of options|Screen reader description of the number of options after filtering the
          combobox@@bb-account-selector-ui.options.count"
      >
        {{ resultCount }} options
      </div>
    </ng-container>
  </ng-template>

  <ng-template ng-notfound-tmp>
    <ng-container>
      <div class="bb-state-container">
        <div class="mb-3 bb-beneficiary-selector-ui__not-found-title"
             i18n="@@beneficiary-selector.not-found.title" [ngStyle]="styleSelect">
          No results found
        </div>
        <div class="mb-0"
             i18n="@@beneficiary-selector.not-found.text">
          We can't find what you are looking for. Please try a different criteria.
        </div>
        <div class="text-center mb-3"
             i18n="@@beneficiary-selector.not-found.text-two" [ngStyle]="styleMessage">
          For additional support, please contact us at 829-893-8200, Dominican Republic free of charges 1-809-200-1101 and Whatsapp 829-647-8100.
        </div>
        <div class="not-found-img"></div>
      </div>
    </ng-container>
  </ng-template>

  <!-- Template for dropdown items list (ng-option-tmp) -->
  <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
    <ng-container>
      <bn-product-item-basic-account-ui
        class="bn-account-selector"
        [active]="item$.selected"
        [amount]="getLocalBalance(item)"
        [foreignAmount]="getForeignAmount(item)"
        [foreignCurrency]="getForeignCurrency(item)"
        [productNumber]="applyMaskToCardNumber(getProductNumber(item))"
        [currency]="item.currency"
        [productNumberFormat]="productNumberFormat"
        [showCurrencySymbol]="showCurrencySymbol"
        [bankBranchCode]="showBankBranchCode ? item.bankBranchCode : undefined"
        [title]="item.name"
        [status]="item.status"
        [highlight]="highlight"
        [balanceLabel]="balanceLabel"
      ></bn-product-item-basic-account-ui>
    </ng-container>
  </ng-template>

  <ng-template ng-loadingtext-tmp>
    <ng-container>
      <bb-loading-indicator-ui
        i18n-text="Loading Accounts|Loading Accounts label @@bb-account-selector-ui.loading.accounts"
        text="Loading Accounts"
      ></bb-loading-indicator-ui>
    </ng-container>
  </ng-template>
</ng-select>
